import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Link from 'react-router-dom/Link';

@autobind
class PrivacyPage extends React.Component {
  state = {
    active: [false,false],
    dropdown: false,
  }; 

  componentDidMount(){
      var ass = [false,false,false,false,false];
      if(window.location.pathname === "/privacy-policy"){
        ass[0] = true;
      } else if(window.location.pathname === "/terms-of-service"){
        ass[1] = true;
      }
      this.setState({active:[...ass]})
  }

render() {
    return (
      <div className={css(styles.wrapper)}>
      	<div className={css(styles.sideNavWrapper)}>
          <Link to="/" className={css(styles.backWrapper)}>
            <img className={css(styles.backImg)} alt="arr down minimaa" src="../../assets/arrDown.svg" />
            <div className={css(styles.backText)}>
              BACK TO MINIMAA.CO
            </div>
          </Link>
          <Link to="/">
            <img alt="minimaa logo" className={css(styles.logo)} src="../../assets/logo.svg" />
          </Link>
          <Link className={css(styles.link)} onClick={()=>window.scrollTo(0,0)} to="/privacy-policy">
              PRIVACY POLICY
          </Link>
          <Link className={css(styles.link)} onClick={()=>window.scrollTo(0,0)} to="/terms-of-service">
              TERMS OF SERVICE
          </Link>
        </div>
        <div>
          <div className={css(styles.topNavWrapper)}>
            <div className={css(styles.topNavFlex)}>
              <Link to="/">
                <img alt="minimaa logo" className={css(styles.logo2)} src="../../assets/logo.svg" />
              </Link>
              <div className={css(styles.menuButton)} onClick={() => this.setState({dropdown: !this.state.dropdown})}>
                MENU
              </div>
            </div>
          </div>
          <div className={css(styles.dropdownWrapper)}>
            <div className={this.state.dropdown ? css(styles.dropdownBoxOn) : css(styles.dropdownBoxOff)}>
              <div className={css(styles.innerWrapper)}>
                <Link className={css(styles.link)} onClick={()=>window.scrollTo(0,0)} to="/privacy-policy">
                    PRIVACY POLICY
                </Link>
                <Link className={css(styles.link)} onClick={()=>window.scrollTo(0,0)} to="/terms-of-service">
                    TERMS OF SERVICE
                </Link>
              </div>
            </div>
          </div>
        </div>
      	<div className={css(styles.pageWrapper)}>
          {this.props.children}
        </div>
      </div> 
    );
  }
}


const styles = StyleSheet.create({
  wrapper:{
    display:"flex",
    alignItems:"stretch",
    minHeight:"100vh",
    '@media (max-width: 900px)': {
      flexDirection:"column",
    },
  },
  sideNavWrapper:{
    width:240,
    background:"#F3F4F7",
    padding:30,
    paddingTop:28,
    '@media (max-width: 900px)': {
      display:"none",
    },
  },
  topNavWrapper:{
    display:"none",
    '@media (max-width: 900px)': {
      display:"block",
      width:"100%",
      paddingTop:15,
      paddingBottom:15,
    },
  },
  topNavFlex:{
    display:"flex",
    height:50,
    margin:"0 auto",
    justifyContent:"space-between",
    alignItems:"center",
    width:"calc(100% - 100px)",
    '@media (max-width: 580px)': {
      width: "calc(100% - 60px)",
    },
    '@media (max-width: 340px)': {
      width: "calc(100% - 40px)",
    }, 
  },

  menuButton:{
    position:"relative",
    display:"flex",
    alignItems:"center",
    justifyContent: 'space-between',
    
    cursor:"pointer",
    fontSize:15,
    fontWeight:600,
    borderRadius:"20px",
    transition:"0.3s",
    ":hover":{
      opacity:0.6,
    },
    '@media (min-width: 900px)': {
      display:"none",
    },
    '@media (max-width: 700px)': {
      ":hover":{
        opacity:1,
      },
    },
  },

  backWrapper:{
    display:"flex",
    justifyContent:"flex-start",
    alignItems:"center",
    transition:"0.2s",

    opacity:0.6,
    textDecoration:"none",
    ":hover":{
      opacity:1,
    },
  },
  backImg:{
    width:16,
    transform:"rotate(90deg)",
    marginRight:6,
  },
  backText:{
    fontSize:12,
    letterSpacing: "0.190909px",
    fontWeight: 500,
    color:"#000",
    textDecoration:"none",
  },


  pageWrapper:{
    width:"100%",
  },
  logo:{
    width:120,
    marginBottom:44,
    marginTop:55,
  },
  logo2:{
    width:120,
    marginBottom:-4,
  },
  link:{
    letterSpacing:0.14,
    textDecoration:"none",
    color:"#000",
    marginBottom:6,
    paddingRight: 4,
    cursor:"pointer",
    borderBottom:"1px solid #000",
    paddingBottom:8,
    fontSize:12,
    fontWeight:600,
    paddingTop:10,
    marginTop:10,
    webkitTransition:"0.2s linear",
    transition:"0.2s linear",
    display:"block",
    alignItems:"center",
    ":hover":{
      opacity:0.6,
    },
    '@media (max-width: 900px)': {
      fontSize:18,
      marginTop:25,
      marginBottom:25,
    },
  },
  linkImgOn:{
    width:18,
    opacity:1,
    marginLeft:10,
    marginBottom:-2,
    transition:"0.2s",
  },
  linkImgOff:{
    width:18,
    opacity:0,
    marginLeft:10,
    marginBottom:-2,
    transition:"0.2s",
  },


  dropdownWrapper:{
    color:"#000",
    transition:"0.4s",
    '@media (min-width: 900px)': {
      display:"none",
    },
  },
  dropdownBoxOn:{
    transition: "0.4s",
    overflow:"hidden",
    display:"flex",
    justifyContent:"center",
    flexDirection:"column",
    alignItems:"center",
    background: "#F3F4F7",
    height:400,
    opacity: 1,
  },
  dropdownBoxOff:{
    transition: "0.4s",
    overflow:"hidden",
    display:"flex",
    justifyContent:"center",
    flexDirection:"column",
    alignItems:"center",
    background: "#F3F4F7",
    height:0,
    opacity: 0,
  },
  innerWrapper:{
    textAlign:"center",
  },
});


export default PrivacyPage;